<template>
    <v-dialog
    v-model="progress"
    hide-overlay
    persistent
    width="300"
  >
    <v-card
      color="primary"
      dark
    >
      <v-card-text>
        Исполняется операция, ожидайте
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  computed: {
    progress: {
      get: function () {
        // return this.$store.getters.getSystemStatus === 'loading'
        return this.$store.getters.getUIStatus === 'busy'
      }
    },
    currStatus: {
      get: function () {
        return this.$store.getters.getUITasks
      }
    }
  }
}
</script>
